import { defineStore } from 'pinia'
import { ref } from 'vue'

export interface AppNotification {
  id: string
  message: string
  type: 'success' | 'error' | 'info'
}

export const useNotificationsStore = defineStore('notifications', () => {
  const notifications = ref<AppNotification[]>([])

  function add(notification: Omit<AppNotification, 'id'>): void {
    // Dedup: identyczny (typ + treść) toast już widoczny nie jest dublowany.
    // Chroni przed podwójnym powiadomieniem (np. szybki double-click „Dodaj do
    // koszyka" na produkcie poza stanem, albo dwie ścieżki zgłaszające ten sam błąd).
    if (notifications.value.some(n => n.type === notification.type && n.message === notification.message)) {
      return
    }
    const id = crypto.randomUUID()
    notifications.value.push({ ...notification, id })
    if (import.meta.client) {
      // Krótki czas dla potwierdzeń: na mobile toast zakrywa CTA „Dodaj do koszyka"
      const delay = notification.type === 'error' ? 6000 : 1500
      setTimeout(() => remove(id), delay)
    }
  }

  function remove(id: string): void {
    const idx = notifications.value.findIndex(n => n.id === id)
    if (idx !== -1) notifications.value.splice(idx, 1)
  }

  return { notifications, add, remove }
})
